import "./AutocompleteSearch.css"
import "./Home.css"
import { Search } from "lucide-react"
import NewBadge from "../NewBadge/NewBadge"

const AutocompleteSearch = ({
                                searchQuery,
                                searchResults,
                                handleSearchQueryChange,
                                handleKeyPress,
                                handleResultSelect,
                                handleSearchFocus,
                                handleSearchBlur,
                                highlightMatch,
                                // Props para IA (opcionales)
                                showAiButton = false, // Por defecto NO muestra el botón IA
                                useAi = false,
                                onToggleAi = () => {},
                                aiResults = [],
                                aiLoading = false
                            }) => {
    // Si se proporciona una función highlightMatch personalizada, la usamos
    // De lo contrario, implementamos la función estándar pero sin espacios adicionales
    const highlightText = highlightMatch || ((text, query) => {
        if (!query) return text
        const regex = new RegExp(`(${query})`, "gi")
        return text.split(regex).map((part, index) =>
            regex.test(part) ? (
                <span key={index} className="highlight">{part}</span>
            ) : (
                part
            ),
        )
    });

    return (
        <div className="autocomplete-search">
            <div className="search-input-wrapper">
                {/* Botón IA a la izquierda - SOLO si showAiButton es true */}
                {showAiButton && (
                    <>
                        <button
                            type="button"
                            className={`ai-toggle ${useAi ? 'active' : ''}`}
                            onMouseDown={(e) => { e.preventDefault(); onToggleAi(!useAi); }}
                            title={useAi ? 'Desactivar búsqueda IA' : 'Activar búsqueda IA'}
                        >
                            <span className="ai-text">IA</span>
                        </button>
                        <NewBadge size="sm" className="search-bar__new-badge" />
                    </>
                )}

                <input
                    type="text"
                    className={`search-input ${showAiButton ? 'with-ai-button' : ''}`}
                    placeholder="¿Qué estás buscando?"
                    value={searchQuery}
                    onChange={handleSearchQueryChange}
                    onKeyDown={handleKeyPress}
                    onFocus={handleSearchFocus}
                    onBlur={handleSearchBlur}
                />


                <Search className="search-icon" />
            </div>

            {/* Si IA está activada: mostrar spinner o resultados */}
            {useAi && searchQuery && (
                <ul className="autocomplete-results">
                    {aiLoading ? (
                        <li key="ai-loading" className="ai-loading">
                            <div className="spinner"></div>
                            <span>Buscando con IA...</span>
                        </li>
                    ) : aiResults.length > 0 ? (
                        aiResults.map((item, idx) => {
                            // Determinar label y subtítulo según tipo
                            let label = '';
                            let subtitle = '';
                            let url = '#';

                            if (item.type === 'category') {
                                label = item.data?.name || item.data?.label || '';
                                subtitle = item.data?.type === 'service' ? 'Servicios' : item.data?.type === 'products' ? 'Productos' : item.data?.type || '';
                                // Construir URL correcta para categoría: /servicios/Nombre o /productos/Nombre
                                const categoryType = item.data?.type === 'service' ? 'servicios' : item.data?.type === 'products' ? 'productos' : item.data?.type;
                                const categoryName = item.data?.name || item.data?.id || '';
                                url = `/${categoryType}/${encodeURIComponent(categoryName)}/proveedores`;
                            } else if (item.type === 'service_provider' || item.type === 'products_provider') {
                                label = item.data?.name || item.data?.username || '';
                                subtitle = item.type === 'service_provider' ? 'Proveedor de Servicios' : 'Proveedor de Productos';
                                // Construir URL correcta para proveedor: /{username}
                                const username = item.data?.username || '';
                                url = `/${username}`;
                            }

                            // Determinar si es el resultado con mayor similitud (índice 0)
                            const isTopResult = idx === 0;

                            return (
                                <li
                                    key={`ai-${idx}`}
                                    className={isTopResult ? 'top-result' : ''}
                                    onMouseDown={() => handleResultSelect(label, url)}
                                >
                                    <div className="result-row">
                                        <span className="result-text">{highlightText(label, searchQuery)}</span>
                                        <span className="result-category">{subtitle}</span>
                                    </div>
                                </li>
                            )
                        })
                    ) : (
                        <li key="no-results-ai" className="no-results">No se encontraron resultados con IA</li>
                    )}
                </ul>
            )}

            {/* Comportamiento original de autocompletado (hashmap) */}
            {!useAi && Object.keys(searchResults).length > 0 && (
                <ul className="autocomplete-results">
                    {Object.entries(searchResults)
                        .filter(([result]) => result && result.trim() !== "") // Filtrar claves vacías o solo espacios
                        .map(([result, url]) => {
                            const [text, category] = result.split(" (")
                            return (
                                <li key={result} onMouseDown={() => handleResultSelect(result, url)}>
                                    <div className="result-row">
                                        <span className="result-text">{highlightText(text, searchQuery)}</span>
                                        {category && <span className="result-category">({category}</span>}
                                    </div>
                                </li>
                            )
                        })}
                </ul>
            )}
            {searchQuery && !useAi && Object.keys(searchResults).length === 0 && (
                <ul className="autocomplete-results">
                    {/* Añadir una clave estática aquí para buena práctica */}
                    <li key="no-results" className="no-results">No se encontraron resultados</li>
                </ul>
            )}
        </div>
    )
}

export default AutocompleteSearch